import script from "./WeekRecordsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeekRecordsList.vue?vue&type=script&lang=ts&setup=true"

import "./WeekRecordsList.vue?vue&type=style&index=0&id=70edd7fe&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70edd7fe"]])

export default __exports__